module.exports = __webpack_public_path__ + "img/9bb21f5.jpg";